import { gqlMutate, gqlQuery } from './common/apolloClient'
import axios from 'axios/index'
import qs from 'qs'
import { API_BRASPAG_CARD_URL } from './common/constants'

import {
  gqlInserirRecarga,
  gqlValoresRecarga,
  gqlDadosPagamento,
  gqlEditarValorRecarga,
  gqlAccessTokenBrasPag,
  transformDadosPagamento,
  transformValoresRecarga
} from './queries/recharges'

const formaPagamentoMap = {
  credit: 'CARTAO_DE_CREDITO',
  debit: 'DEBITO_EM_CONTA',
  bankSlip: 'BOLETO'
}
const atividadeMap = {
  manual: 'RECARGA_MANUAL',
  auto: 'RECARGA_AUTOMATICA'
}

export async function createRecharge(accountPlanId, value, paymentMethod, type) {
  await gqlMutate(gqlInserirRecarga, {
    conta: accountPlanId,
    valor: value,
    atividade: atividadeMap[type],
    formaPagamento: formaPagamentoMap[paymentMethod],
    canal: 'site'
  })
}

export async function getRechargeValues(accountPlanId) {
  const gqlResp = await gqlQuery(gqlValoresRecarga, { idConta: accountPlanId })
  return transformValoresRecarga(gqlResp)
}

export async function getPaymentInfo(accountPlanId) {
  const gqlResp = await gqlQuery(gqlDadosPagamento, { conta: accountPlanId })
  return transformDadosPagamento(gqlResp)
}

export async function changeRecharge(accountPlanId, valorRecarga) {
  await gqlMutate(gqlEditarValorRecarga, { conta: accountPlanId, valor: valorRecarga })
}

export async function getBrasPagAccessToken() {
  const { data: { accessTokenBrasPag } } = await gqlQuery(gqlAccessTokenBrasPag)
  return { data: accessTokenBrasPag }
}

const normalizeValidade = src => {
  let [mes, ano] = src.split('/')
  if (!mes || !ano || ![2, 4].includes(ano.length)) throw new Error('Data de validade inválida')
  if (ano.length === 2) {
    ano = `20${ano}`
  }
  return `${mes}/${ano}`
}

export async function postBraspagCard(
  HolderName,
  RawNumber,
  Expiration,
  SecurityCode,
  AccessToken
) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  }

  return axios.post(
    API_BRASPAG_CARD_URL,
    qs.stringify({
      HolderName,
      RawNumber,
      Expiration: normalizeValidade(Expiration),
      SecurityCode,
      AccessToken
    }),
    {
      headers
    }
  )
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/rechargeService.js